import React from 'react'
import ProductPrices from '@components/ui/PriceComparison'
import { BREAKPOINT_SIZES } from '@consts/index'
import { useMediaQuery } from '@helpers/hooks'
import ProductCardProperties, { ProductCardPropertiesProps } from './ProductCardProperties'
import styles from './styles.module.scss'
import ProductCardHeader from './ProductCardHeader'
import ProductCardImage from './ProductCardImage'

type ProductCardProps = {
  title: string
  image: string
  price?: {
    paidPrice: number
    fullPrice: string
  }
  classes?: string
  imageClasses?: string
} & ProductCardPropertiesProps

const ProductCard = ({
  title,
  image,
  properties,
  newPropertiesToCompare,
  price,
  classes,
  imageClasses,
  children
}: React.PropsWithChildren<ProductCardProps>) => {
  const { paidPrice, fullPrice } = price || {}

  const isSmallScreenView = useMediaQuery({
    maxWidth: BREAKPOINT_SIZES.TABLET - 1
  })
  const imageConfig = {
    imgWidth: isSmallScreenView ? '288' : '328',
    imgHeight: isSmallScreenView ? '400' : '432'
  }
  return (
    <div className={`${styles.productCard} ${classes || ''}`}>
      <div className={styles.productCard__container}>
        <ProductCardImage img={image} imageConfig={imageConfig} title={title} />
        <div className={styles.productContent}>
          <ProductCardHeader title={title}>
            {(fullPrice != null || paidPrice != null) && (
              <div className={styles.productCard__price}>
                <ProductPrices price={paidPrice ?? null} fullPrice={fullPrice ?? null} size="medium-bold" />
              </div>
            )}
          </ProductCardHeader>
          <ProductCardProperties properties={properties} newPropertiesToCompare={newPropertiesToCompare} />
        </div>
      </div>
      {children}
    </div>
  )
}

export default ProductCard
